import tailwind from './src/styles/tailwind.css'
import wrapWithProvider from "./wrap-with-provider"

export const wrapRootElement = wrapWithProvider